import { render, staticRenderFns } from "./SidebarLeft.vue?vue&type=template&id=64e47d82&scoped=true"
import script from "./SidebarLeft.vue?vue&type=script&lang=js"
export * from "./SidebarLeft.vue?vue&type=script&lang=js"
import style0 from "./SidebarLeft.vue?vue&type=style&index=0&id=64e47d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e47d82",
  null
  
)

export default component.exports